import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import heroImage from "../../Assets/Images/headerPic.svg";

const Header = ({
  breadcrumbs = [
    { label: "HOME", path: "/" },
    { label: "BLOG & NEWS", path: "/blog" },
    { label: "BLOGS", path: "/blogs/our-blogs" },
  ],
  title = "Articles",
  description = "Egestas sed tempus urna et pharetra. Leo integer malesuada nunc vel. Libero id faucibus nisl tincidunt eget nullam non nisi. Faucibus turpis in eu mi bibendum neque egestas",
  heroCards = [],
  heroConfig = {
    columns: 2,
    gap: 4,
    border: "20px",
    animation: true,
  },
}) => {
  return (
    <div className="relative bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 overflow-hidden">
      <div className="relative px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <motion.div
            className="space-y-8"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* Breadcrumbs */}
            <motion.div
              className="flex flex-wrap items-center gap-3"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {breadcrumbs.map((crumb, index) => (
                <div key={index} className="flex items-center gap-3">
                  <a
                    href={crumb.path}
                    className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-300 ${
                      index === breadcrumbs.length - 1
                        ? "bg-black text-white shadow-lg"
                        : "bg-white/80 text-gray-600 hover:bg-white hover:text-gray-900 hover:shadow-md backdrop-blur-sm"
                    }`}
                  >
                    {crumb.label}
                  </a>
                  {index < breadcrumbs.length - 1 && (
                    <span className="text-gray-400 text-sm">›</span>
                  )}
                </div>
              ))}
            </motion.div>

            {/* Title */}
            <motion.h1
              className="text-5xl sm:text-5xl lg:text-6xl xl:text-8xl font-black leading-tight"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <span className="bg-gradient-to-r from-black via-gray-800 to-gray-600 bg-clip-text text-transparent heading">
                {title}
              </span>
            </motion.h1>

            {/* Description */}
            <motion.p
              className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-xl sub-heading tracking-wide"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              {description}
            </motion.p>
          </motion.div>

          {/* Right Hero Section */}
          <motion.div
            className="relative h-full w-full"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="w-full h-full rounded-3xl overflow-hidden">
              <img
                src={heroImage}
                alt="Hero"
                className="w-full h-full object-contain transform hover:scale-105 transition-transform duration-700"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Header;
